.specialCard:hover {
  border-color: var(--colors-transparent-black-twenty);
}

.specialCardDefaultImage {
  aspect-ratio: 2 / 1;
}

.specialCardLink {
  display: block;
  width: 100%;
  height: 100%;
}
